import ScrollReveal from "@stimulus-components/scroll-reveal";

export default class extends ScrollReveal {
  static values = {
    ...ScrollReveal.values,
    hiddenClass: String,
  };

  declare readonly hiddenClassValue: string;
  declare readonly hasHiddenClassValue: boolean;
  declare readonly itemTargets: HTMLElement[];

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.itemTargets.forEach((item) => item.classList.add(...this.revealClasses));
      return;
    }

    this.itemTargets.forEach((item) => item.classList.add(...this.hiddenClasses));

    super.connect();
  }

  disconnect() {
    if (this.observer) super.disconnect();
  }

  intersectionObserverCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > this.threshold) {
        entry.target.classList.remove(...this.hiddenClasses);
      }
    });

    super.intersectionObserverCallback(entries, observer);
  }

  private get hiddenClasses() {
    return (this.hiddenClassValue || "opacity-0 translate-y-6").split(" ");
  }

  private get revealClasses() {
    return (this.classValue || "opacity-100 translate-y-0").split(" ");
  }
}
